/* eslint-disable import/no-cycle */
import React, {useState} from 'react';
import Highcharts from 'highcharts';
import {observer} from 'mobx-react-lite';
import moment from 'moment';
import {useStore} from '../../../../hooks/useStore';
import {useMount} from '../../../../hooks/useMount';
import Chart from '../../../shared/charts/Chart';
import {dateFormat} from '../../../../config/moment';

const KpiLossChart = ({
  workplaceId,
  kpiIds,
  daysBack,
  fromDate,
  toDate,
  unitOfMeasurement,
  yAxisMax,
  yAxisTitle,
  showPercent,
}) => {
  const store = useStore();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useMount(() => {
    (async () => {
      setIsLoading(true);
      await store.keyPerformanceIndicatorStore.loadMany(kpiIds);

      if (workplaceId && fromDate && toDate) {
        const kpiResponse = await store.keyPerformanceIndicatorStore.loadKpiByTime({
          workplaceId,
          fromDate,
          toDate,
          resolution: daysBack,
          kpiId: kpiIds,
        });

        const hasDisplayableData = kpiResponse.reduce((acc, curr) => acc + curr.data.length, 0);
        let kpiValues;

        if (hasDisplayableData) {
          kpiValues = kpiResponse.map((response) => ({
            data: response.data
              ? response.data.slice(0, response.data.length - 1).map((r) => ({x: r.x, y: r.y || 0}))
              : [],
            kpi: store.keyPerformanceIndicatorStore.getById(response.kpiId),
            kpiId: response.kpiId,
            dates: response.data.map((r) => moment(r.x)),
          }));
        }

        setData(kpiValues);
        setIsLoading(false);
      }
    })();
  }, [workplaceId, kpiIds?.join(''), daysBack]);

  const options = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: data
        ? data[0]?.dates?.map((d) => d.format(dateFormat))
        : [],
    },
    yAxis: {
      labels: {
        formatter: (axis) => `${axis.value} ${showPercent ? '%' : unitOfMeasurement?.label || ''}`,
      },
      max: yAxisMax || null,
      title: {
        text: yAxisTitle || null,
      },
    },
    series: data?.map((entry) => ({
      name: entry.kpi.name,
      data: entry.data.map((d) => Number(d.y.toFixed(2))),
    })),
    plotOptions: {
      column: {
        stacking: showPercent ? 'percent' : 'normal',
        dataLabels: {
          enabled: true,
          pointFormat: showPercent ? '{point.percentage:.1f}%' : null,
        },
      },
    },
    legend: {
      layout: 'vertical',
      align: 'right',
    },
  };

  return (
    <Chart options={options} highcharts={Highcharts} isLoading={isLoading} showIsEmpty={!data?.length}/>
  );
};

export default observer(KpiLossChart);
